import _ from 'lodash';

import { Authority } from ".";

export const linkedAccount = (authority: Authority) => _.get(authority, 'authorityCS.linkedAccount')
export const firstAlias = (authority: Authority) => _.get(authority, 'alias[0]', null)